import {kitFetch} from "@ekultur/fetch";

export const getUserData = () => kitFetch(`/authz/authorize/userData`)

